import { DeleteFilled, EditFilled } from "@ant-design/icons";
import { Button, Popconfirm, Space } from "antd";

export const getColumn = ({ editAction, deleteAction }) => {
    return [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            width: 240,
            render: (text) => <span>{text}</span>,
            sorter: (a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            },
        },
        {
            title: "Color",
            dataIndex: "color",
            key: "color",
            width: 120,
            render: (value) => (
                <div style={{ backgroundColor: value }} className="m-auto w-[20px] h-[20px] rounded-full overflow-hidden"></div>
            )
        },
        {
            title: "Order",
            dataIndex: "value",
            key: "value",
            width: 120,
        },
        {
            title: "Action",
            key: "action",
            width: 60,
            render: (_, record) => {
                return (
                    <Space size="middle">
                        <Button
                            type="text"
                            icon={<EditFilled />}
                            onClick={() => editAction(record)}
                        />
                        <Popconfirm title={`¿Seguro eliminar?}`} onConfirm={() => deleteAction(record.key)}>
                            <Button type="text" icon={<DeleteFilled />} />
                        </Popconfirm>
                    </Space>
                );
            },
        },
    ]
}